const reasons: Record<string, string> = {
  permission_required: 'A company billing manager can change this plan.',
  billing_review:
    'Billing needs a review before the plan can change. Contact support to resolve the billing hold.',
  changes_paused:
    'Self-service plan changes are currently paused. Contact support to change your existing plan; it remains active at its agreed price.',
  change_pending:
    'A plan change or payment is already being processed. Reopen Billing after it completes.',
  change_scheduled:
    'A change is already scheduled. Review or cancel the scheduled change before choosing another plan.',
  payment_pending:
    'A subscription payment is awaiting confirmation. Complete the payment before changing plans.',
  active_subscription_required:
    'Plan changes require an active paid subscription. Review your current subscription or contact support.',
};
export const planChangeExplanation = (reason?: string | null) =>
  Object.prototype.hasOwnProperty.call(reasons, reason ?? '')
    ? reasons[reason!]
    : 'Plan changes are unavailable. Contact support for help with this account.';
